<template>
    <div>
        <div class="order-userInfo">
            <div class="userInfo-wrapper" >
                <div class="userInfo-border" >
                    <h5>基本设置</h5>
                    <el-row class="userInfo-group" >
                        <el-row>
                            <el-col :span="8" class="order-item" >服务时间：<span>{{new Date(product.content.start_at).toLocaleDateString()}}-{{new Date(product.content.end_at).toLocaleDateString()}}</span></el-col>
                        </el-row>
                    </el-row>
                </div>
            </div>
            <div class="userInfo-wrapper" style="text-align:center" >
                    暂无配置信息
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        product: {
            type: Object
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/order/products/paike.vue